<template>
    <div class="social-icons">
        <a
            v-if="youtube"
            :href="youtube"
            target="_blank"
            class="social-icons__icon social-icons__icon--youtube"
        >
            <IconRenderer
                name="YouTube"
            />
        </a>

        <a
            v-if="facebook"
            :href="facebook"
            target="_blank"
            class="social-icons__icon social-icons__icon--facebook"
        >
            <IconRenderer
                name="Facebook"
            />
        </a>

        <a
            v-if="twitter"
            :href="twitter"
            target="_blank"
            class="social-icons__icon social-icons__icon--twitter"
        >
            <IconRenderer
                name="Twitter"
            />
        </a>

        <a
            v-if="linkedin"
            :href="linkedin"
            target="_blank"
            class="social-icons__icon social-icons__icon--linkedin"
        >
            <IconRenderer
                name="LinkedIn"
            />
        </a>
    </div>
</template>

<script>
import KeyValue from "@/services/lookup/key-value";

export default {
    data(){
        return {
            facebook: null,
            twitter: null,
            linkedin: null,
            youtube: null,
        }
    },

    mounted(){
        KeyValue.show('footer', 'follow-link-facebook').then(val => {
            this.facebook = val;
        });
        KeyValue.show('footer', 'follow-link-twitter').then(val => {
            this.twitter = val;
        });
        KeyValue.show('footer', 'follow-link-linkedin').then(val => {
            this.linkedin = val;
        });
        KeyValue.show('footer', 'follow-link-youtube').then(val => {
            this.youtube = val;
        });
    }
}
</script>

<style>
.social-icons {
    @apply w-full flex flex-row;

    &__icon {
        @apply w-14 h-14 rounded-full lg:w-16 lg:h-16 flex justify-center items-center mr-4 cursor-pointer;

        svg {
            @apply w-1/2 h-auto;
        }

        &--facebook {
            svg {
                @apply w-auto h-1/2;
            }
        }

        &--linkedin {
            svg {
                @apply w-auto h-2/5;
            }
        }
    }
}
</style>
